function formatFirestoreDate(dateStr) {
  if (!dateStr) return '';

  let date;
  // Handle Firestore Timestamp
  if (dateStr && typeof dateStr.toDate === 'function') {
    date = dateStr.toDate();
  } else {
    date = new Date(dateStr);
  }

  // Check for invalid date
  if (isNaN(date.getTime())) return '';

  // Format: "Fri, Jul 18"
  const dateOptions = { weekday: 'short', day: 'numeric', month: 'short' };
  const formattedDate = date.toLocaleDateString('en-US', dateOptions);

  // Format time: "9PM" or "10:30PM"
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes > 0 ? `:${minutes.toString().padStart(2, '0')}` : '';
  const formattedTime = `${displayHours}${displayMinutes}${ampm}`;

  // Return: "Fri, Jul 18 | 9PM"
  return `${formattedDate} | ${formattedTime}`;
}

export { formatFirestoreDate };
